import React from "react";
import { Text, View } from "@/styles/reactnative";
import { CryptoCurrencyTrendFooterSection } from "../styles";

const CryptoMarketFooter = () => {
  const data = [
    { name: "all", color: "black" },
    { name: "ada", color: "orange" },
    { name: "bnb", color: "blue" },
    { name: "btc", color: "green" },
    { name: "busd", color: "yellow" },
    { name: "doge", color: "green" },
    { name: "eth", color: "purple" },
    { name: "ltc", color: "skyblue" },
    { name: "usdc", color: "gold" },
    { name: "usdt", color: "pink" },
    { name: "weth", color: "purple" },
    { name: "xrp", color: "brown" },
  ];

  return (
    <CryptoCurrencyTrendFooterSection>
      {data.map((item, index) => (
        <View
          key={index.toString()}
          style={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 10,
            marginRight: 10,
          }}
        >
          <Text
            style={{
              background: item?.color,
              height: 6,
              width: 6,
              borderRadius: 50,
              marginBottom: 2,
              marginInline: 10,
            }}
          ></Text>
          <Text>{item?.name?.toUpperCase()}</Text>
        </View>
      ))}
    </CryptoCurrencyTrendFooterSection>
  );
};

export default React.memo(CryptoMarketFooter);
